import { createAsyncThunk } from '@reduxjs/toolkit';

import { entitiesActions } from '../slices/entitiesSlice';
import type { RootState } from '../store';

import { eventsService } from './_deps';

export const fetchEventById = createAsyncThunk<void, { eventId: string }, { state: RootState }>(
  'events/fetchById',
  async ({ eventId }, thunkApi) => {
    const { dispatch } = thunkApi;
    const event = await eventsService.getEvent({ eventId });
    dispatch(entitiesActions.upsertEvent(event));
  },
);
